import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/settings/cities";
const apiDropDownEndpoint = API_BASE_URL_ENV() + "/admin/settings/dropdown/City?status=1";

export default class CitiesService {

    getDropDown=()=>{
      return  http.get(apiDropDownEndpoint) 
    }

}
